export enum TaxableAnnualIncome {
    UpTo30k = 30000,
    UpTo40k = 40000,
    UpTo50k = 50000,
    UpTo60k = 60000,
    Over60k = 100000
}
